import { io } from 'socket.io-client';

class DealerSocketService {
  constructor() {
    this.socket = null;
    this.isConnected = false;
    this.notificationCallbacks = [];
  }

  // Connect to dealer socket
  connect(token) {
    if (this.socket) {
      this.disconnect();
    }

    // Get the backend URL from environment or use default
    const SOCKET_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

    // Connect to dealer socket with specific path
    this.socket = io(SOCKET_URL, {
      path: '/dealer-socket',
      transports: ['websocket', 'polling']
    });

    // Handle connection events
    this.socket.on('connect', () => {
      console.log('Connected to dealer socket');
      this.isConnected = true;
    });

    this.socket.on('disconnect', () => {
      console.log('Disconnected from dealer socket');
      this.isConnected = false;
    });

    this.socket.on('error', (error) => {
      console.error('Dealer socket error:', error);
    });

    // Authenticate with token
    this.socket.emit('authenticate', token);

    // Listen for authentication response
    this.socket.on('authenticated', (data) => {
      console.log('Dealer authenticated:', data);
      // Subscribe to notifications
      this.socket.emit('subscribeToNotifications');
    });

    // Listen for dealer notifications
    this.socket.on('dealerNotification', (notification) => {
      console.log('Dealer notification received:', notification);
      this.notificationCallbacks.forEach(callback => callback(notification));
    });

    // Listen for subscription confirmation
    this.socket.on('notificationSubscribed', (data) => {
      console.log('Subscribed to dealer notifications:', data);
    });
  }

  // Disconnect from socket
  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.isConnected = false;
    }
  }

  // Add notification listener
  onNotification(callback) {
    this.notificationCallbacks.push(callback);
    return () => {
      const index = this.notificationCallbacks.indexOf(callback);
      if (index > -1) {
        this.notificationCallbacks.splice(index, 1);
      }
    };
  }

  // Test connection
  testConnection() {
    if (this.socket) {
      this.socket.emit('testDealerConnection', { message: 'Test from React' });
    }
  }

  // Listen for test response
  onTestResponse(callback) {
    if (this.socket) {
      this.socket.on('dealerTestResponse', callback);
    }
  }

  // Update dealer status
  updateStatus(status) {
    if (this.socket) {
      this.socket.emit('updateDealerStatus', status);
    }
  }

  // Get connection status
  getConnectionStatus() {
    return this.isConnected;
  }
}

// Create singleton instance
const dealerSocketService = new DealerSocketService();
export default dealerSocketService; 